<template>
  <div class="table-container-page display-col full-height">
    <div class="lx-flex-shrink-0 lx-flex-row-between" v-if="showBreadCrumb=='1'&&canReturn=='0'">
      <BreadCrumb />
      <div style="margin-bottom:10px">
        <a v-if="link2!=='#'" target="_blank" :href="link2" style="margin-right:20px">{{$t('excel.excel14')}}</a>
        <a v-if="link3!=='#'" target="_blank" :href="link3" style="margin-right:20px">{{$t('excel.excel12')}}</a>
        <a v-if="link4!=='#'" target="_blank" :href="link4">{{$t('excel.excel13')}}</a>
      </div>
    </div>
    <div class="breadcrumb-container editBread-container" v-if="showBreadCrumb=='1'&&canReturn=='1'">
      <slot name="editBreadcrumb"></slot>
    </div>

    <div class="search-container">
      <slot name="search"></slot>
    </div>
    <div class="table-container flex1 lx-flex-column lx-hidden">
      <slot name="table"></slot>
    </div>
  </div>
</template>

<script>
import BreadCrumb from './layout/components/breadCrumb'
export default {
  data () {
    return {
      link2: '#',
      link3: '#',
      link4: '#'
    }
  },
  props: {
    canReturn: {
      default: '0'
    },
    showBreadCrumb: {
      default: '1'
    }
  },
  components: { BreadCrumb },
  methods: {
    async loadLinks () {
      try {
        const res = await this.$http.get('basicInfoConfig/getSomeConfig', { params: { type: [3, 4, 5] }, headers: { noLoading: true } })
        this.link2 =  res?.data?.data?.detailedInspectionSpecification ? process.env.VUE_APP_BASE_DOMAIN + res?.data?.data?.detailedInspectionSpecification : '#'
        this.link3 =  res?.data?.data?.operationManual ? process.env.VUE_APP_BASE_DOMAIN + res?.data?.data?.operationManual : '#'
        this.link4 =  res?.data?.data?.pricingInformation ? process.env.VUE_APP_BASE_DOMAIN + res?.data?.data?.pricingInformation : '#'
      } catch (e) {}
    }
  },
  created () {
    this.loadLinks()
  }
};
</script>

<style lang="less" scoped>
a {
  color: black;
  text-decoration: none;
}
// .table-container-page {
//   // overflow: auto;
// }
.editBread-container {
  padding-bottom: 10px;
}
.search-container {
  // height: 120px;
  background-color: #fff;
  padding: 10px;
  border-radius: 5px;
}
.table-container {
  margin-top: 10px;
  overflow: hidden;
  background-color: #fff;
  padding: 10px;
  border-radius: 5px;
}
.breadcrumb {
  display: flex;
  justify-content: space-between;
}
</style>
